<template>
<v-main>
  <v-layout row class="pa-6" justify-center>
    <v-card class="px-5 rounded-xl mx-2" width="1200">
      <v-card-title>
        Editar painel
      </v-card-title>
      <div class="mt-4">
        <v-form v-model="valid" ref="form">
          <!-- video obj: {{objectVideoEscolhido}} -->
          <!-- lista:{{listaVideos}} -->
          <v-layout row class="mx-1">
            <v-flex md6 xs6 sm12 class="pr-1">
              <v-text-field v-model="login" disabled :type="'text'" name="input-10-1" label="Login" counter @click:append="show1 = !show1"></v-text-field>
            </v-flex>
            <v-flex md6 xs6 sm12 class="pl-1">
              <v-text-field label="Identificação" v-model="nome" :rules="nameRules" required></v-text-field>
            </v-flex>

            <v-flex md6 xs6 sm12 class="pr-1">
              <v-autocomplete v-model="idLocalEscolhido" item-value="idLocal" item-text="nomeLocal" :items="listaLocais" :readonly="!isEditing" label="Local" :rules="[(v) => !!v || 'Adicione uma Local !!']" persistent-hint required>
              </v-autocomplete>
            </v-flex>
            <v-flex md6 xs6 sm12 class="pl-1">
              <v-autocomplete v-model="objectVideoEscolhido" :return-object="true" item-value="idVideo" item-text="nome" :items="listaVideos" :readonly="!isEditing" label="Vídeo" :rules="[(v) => !!v || 'Adicione uma Vídeo !!']" persistent-hint required>
              </v-autocomplete>
            </v-flex>
            <v-flex md12 xs12 sm12>

              <v-autocomplete label="Anúncios" v-model="mAnuncios" item-value="idAnuncio" item-text="nome" :items="anuncios" multiple>
              </v-autocomplete>
            </v-flex>
            <v-flex md6 xs6 sm12 class="pr-1">
              <v-radio-group class="mb-4 pb-1" :rules="[(v) => !!v || 'Campo obrigatório']" v-model="modoVisualizacao" hide-details>
                <template v-slot:label>
                  <strong>Quais chamadas você deseja mostrar?</strong>
                </template>
                <v-radio value="recepcao" label="Recepção"></v-radio>
                <v-radio value="medico" label="Médico"></v-radio>
                <v-radio value="recepcao-medico" label="Recepção e Médico"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex md6 xs6 sm12 class="pl-1">
              <v-checkbox v-model="checkboxSenha" label="Deseja alterar a senha ?"></v-checkbox>
              <div>
                <v-text-field :disabled="!checkboxSenha" v-model="senha" :append-icon="show1 ? 'visibility' : 'visibility_off'" :rules="senhaRules" :type="show1 ? 'text' : 'password'" label="Nova senha" counter @click:append="show1 = !show1"></v-text-field>
              </div>
            </v-flex>

              <v-divider />
            <v-flex xs12 sm12>
              <v-checkbox label="Exibir transmissão de canais no painel?" v-model="isTelevisao" :false-value='0' :true-value='1' required></v-checkbox>
            </v-flex>

            <v-flex xs12 sm12>
              <v-slider thumb-label="always" v-model="volume" append-icon="volume_up" prepend-icon="volume_down" min="0" max="100" label="Volume"></v-slider>
            </v-flex>
            </v-layout>

            <v-alert :value="erroLogin" color="error" icon="warning" outlined>
              Username já existente !!
            </v-alert>

            <v-alert :value="sucessoLogin" color="success" icon="check_circle" outlined>
              Painel alterado com sucesso !!
            </v-alert>
        </v-form>
      </div>
      <v-card-actions>
        <v-spacer />
        <v-btn rounded dark :disabled="desabilitar" @click="submit" :class="{ red: !valid, green: valid }">Salvar</v-btn>
            <v-btn outlined rounded  to='/listaPaineisUnidade'>
              <v-icon left>keyboard_backspace</v-icon>
              voltar
            </v-btn>
      </v-card-actions>
    </v-card>
  </v-layout>
</v-main>
</template>

<script>
import Cookies from 'js-cookie'
import administradorUnidadeService from '../../../services/administradorUnidade.service'

export default {
  name: 'cadastrarAtendenteUnidade',
  data () {
    return {
      show1: false,
      desabilitar: false,
      valid: false,
      isTelevisao: '',
      anuncios: [],
      mAnuncios: [],
      tipo: 6,
      login: '',
      isEditing: true,
      idLocalEscolhido: '',
      objectVideoEscolhido: '',
      modoVisualizacao: '',
      idVideoEscolhido: '',
      erroLogin: false,
      sucessoLogin: false,
      senha: '',
      anunciosSelecionados: [],
      respostaServidor: '',
      idUnidadeEscolhida: '',
      username: '',
      nome: '',
      listaLocais: [],
      listaVideos: [],
      rules: {
        min: v => v.length >= 8 || 'minimo 8 caracteres'
      },
      senhaRules: [
        (v) => v && v.length > 4 || v === '' || 'senha deve ter mais de 4 digitos'
      ],
      nameRules: [
        (v) => !!v || 'Identificação obrigatório',
        (v) => v && v.length > 5 || 'Identificação deve ter mais de 5 caracteres '
      ],
      checkbox: false,
      checkboxSenha: false,
      volume: 0

    }
  },

  methods: {

    retornarAnuncios () {
      administradorUnidadeService.administradorUnidade.retornarAnuncios().then(r => {
        if (r.status == 200) {
          this.anuncios = r.data
        }
      })
    },
    organizarAnuncios (string) {
      var ids = string.split(',')
      ids.forEach(element => {
        this.mAnuncios.push(parseInt(element))
        this.anunciosSelecionados.push(element)
      })
      console.log('mAnuncios', this.mAnuncios)
    },
    retornarLocais () {
      console.log('em retornar locais adm...')
      administradorUnidadeService.administradorUnidade
        .retornarLocais(this.user.idEmpresa)
        .then(rsp => {
          console.log('rsp oi locais:', rsp.data)
          this.listaLocais = rsp.data
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    },

    retornarVideos () {
      console.log('em retornar videos adm...')
      administradorUnidadeService.administradorUnidade
        .retornarVideos()
        .then(rsp => {
          console.log('rsp oi:')
          console.log(rsp.data)
          this.listaVideos = rsp.data
          // this.listaVideos.map(video => delete video.nome)
          this.objectVideoEscolhido = this.listaVideos.find(video => video.idVideo == this.idVideoEscolhido)
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    },

    clear () {
      this.$refs.form.reset()
      this.erroLogin = false
    },

    submit () {
      if (this.$refs.form.validate()) {
        var anuncios = []
        this.anuncios.forEach(e => {
          let isAnuncio = false
          this.mAnuncios.forEach(anuncio => {
            if (e.idAnuncio === anuncio) {
              isAnuncio = true
            }
          })
          if (isAnuncio) {
            anuncios.push({ idAnuncio: e.idAnuncio, status: 1 })
          } else {
            anuncios.push({ idAnuncio: e.idAnuncio, status: 0 })
          }
        })
        let anunciosSelecionados = []
        if (this.anunciosSelecionados.length <= 0) {
          anuncios.forEach(element => {
            if (element.status == 1) {
              anunciosSelecionados.push(element)
            }
          })
        } else {
          anuncios.forEach(a => {
            let isA = false
            this.anunciosSelecionados.forEach(mA => {
              console.log(mA, a.idAnuncio, a.status)
              if (mA === `${a.idAnuncio}` && a.status == 1) {
                isA = true
              }
            })
            if (!isA) { anunciosSelecionados.push(a) }
          })
        }
        anunciosSelecionados.sort(function (a, b) {
          if (a.status > b.status) return -1
          if (a.status < b.status) return 1
          return 0
        })
        console.log('Anuncios', anunciosSelecionados)
        this.desabilitar = true

        if (!this.checkboxSenha) {
          console.log('zerar senha..')
          this.senha = ''
        }
        var video = JSON.parse(JSON.stringify(this.objectVideoEscolhido))
        // delete video.nome
        console.log('obj video', video)
        console.log(this.$route.params)
        administradorUnidadeService.administradorUnidade
          .alterarFuncionario(this.idLocalEscolhido, this.nome, this.tipo,
            this.login, this.senha, this.isTelevisao, this.volume, video, this.modoVisualizacao, anunciosSelecionados, this.$route.params.item.idFuncionario)
          .then(rsp => {
            console.log('rsp oi:')
            console.log(rsp.data)
            if (rsp.data == 'usernameExistente') {
              this.erroLogin = true
              this.desabilitar = false
            }
            if (rsp.data == true) {
              this.sucessoLogin = true
              this.clear()
              setTimeout(() => this.$router.push({
                path: '/listaPaineisUnidade'
              }), 2000)
            }
          })
          .catch(err => {
            // handle your error here
            console.log(err)
          })
      }
    },

    limpar () {
      this.senha = ''
      this.nome = ''
      this.idUnidadeEscolhida = ''
    }

  },
  created () {
    console.log('created...')
  },
  mounted () {
    console.log('em mounted lista unid...')
    console.log('parametro', this.$route.params.item)
    this.retornarAnuncios()
    if (!this.$route.params.item) {
      this.$router.push('/listaPaineisUnidade')
      return
    }
    this.limpar()
    var isTelevisao = this.$route.params.item.isTelevisao
    this.$route.params.item.isTelevisao == null ? this.isTelevisao = 0 : this.isTelevisao = this.$route.params.item.isTelevisao
    this.$route.params.item.volume == null ? this.volume = 50 : this.volume = this.$route.params.item.volume
    this.login = this.$route.params.item.username

    this.nome = this.$route.params.item.nome
    this.idLocalEscolhido = this.$route.params.item.idLocal
    this.idVideoEscolhido = this.$route.params.item.idVideo
    this.modoVisualizacao = this.$route.params.item.modoVisualizacao

    this.user = this.$store.getters.usuario
    this.retornarLocais()
    this.retornarVideos()
    this.organizarAnuncios(this.$route.params.item.idAnuncios)
  }
}
</script>
